import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const NRTRadioButton = (props) => {

    const checkedCls = props.checked ? ' checked ' : ' '

    return (
        <div className={'nrt-radio-button ' + checkedCls}
             onClick={()=>props.onClick(props.option)}>
            <span>{props.option.display}</span>
        </div>
    )
}

NRTRadioButton.propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func,
    option: PropTypes.object.isRequired ,
}

NRTRadioButton.defaultProps = {
    checked: false,
    onClick: () => null,
}

export default NRTRadioButton



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/RadioGroup/RadioButton/index.js